import React from 'react'
import PropTypes from 'prop-types'
import {connect} from 'react-redux'
import {reactTableColumn} from '../../helpers/reactTable'
import CFXProReactTable from '../cfxProReactTable'
import {HEIFER_INDEX} from '../../constants'
import {deleteFinishing} from '../../actions'
import {withRouter} from 'react-router'
import {syncObjectDelete} from '../../helpers/syncing'
import {actionButtons} from '../../helpers/button'
import api from '../../api'

@withRouter
@connect((state) => {
  const {
    app: {isLoggedIn},
    userData: {finishings, userId},
  } = state

  return {
    isLoggedIn,
    userId,
    finishings,
  }
})
@api
class FinishingList extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      deletingId: null,
    }
  }

  localDeleteFinishing = (id) => {
    const {isLoggedIn, userId, apiInstance, dispatch} = this.props

    if (isLoggedIn) {
      this.setState({deletingId: id})
      syncObjectDelete(apiInstance, {userId, id}, dispatch, 'Finishing')
        .then((response) => {
          this.setState({deletingId: null})
        })
        .catch((err) => {
          this.setState({deletingId: null})
        })
    } else {
      dispatch(deleteFinishing(id))
    }
  }

  render() {
    const {finishings} = this.props
    const {deletingId} = this.state

    const data = Object.values(finishings)

    return (
      <div>
        <CFXProReactTable
          fixedHeaders={true}
          titleText="FINISHING"
          rightButtonIconName="fa-plus-circle"
          rightButtonCallback={() => {
            this.props.history.push('/breakeven/finishing/calculator')
          }}
          data={data}
          className="-striped -highlight"
          showPagination={data != null && data.length > 10}
          defaultPageSize={10}
          columns={[
            reactTableColumn('Scenario', 'purchaseWeight', '', (cell) => (
              <div className="cell-value">
                {cell.original.inWeight}lb{' '}
                {cell.original.type === HEIFER_INDEX ? 'Heifer' : 'Steer'}
              </div>
            )),
            reactTableColumn('Purchase Date', 'purchaseDate'),
            reactTableColumn('In Weight', 'inWeight'),
            reactTableColumn('Purchase $/lb', 'purchasePricePerLb'),
            reactTableColumn('Hedgeable Price', 'hedgeablePrice'),
            reactTableColumn('Profit/Loss', 'profitLoss'),
            reactTableColumn('Breakeven PP', 'breakevenPP'),
            reactTableColumn('Breakeven Basis', 'breakevenBasis'),
            reactTableColumn('Breakeven CDN $', 'breakevenCDN'),
            reactTableColumn('Breakeven Futures', 'breakevenFutures'),
            reactTableColumn('Cost of Gain $/lb', 'costOfGain'),
            reactTableColumn('Actions', 'id', '', ({row}) => (
              <div className="cell-value">
                {actionButtons(
                  row,
                  deletingId,
                  '/breakeven/finishing/calculator/' + row.id,
                  this.localDeleteFinishing,
                )}
              </div>
            )),
          ]}
        />
      </div>
    )
  }
}

const FinishingItem = PropTypes.shape({
  id: PropTypes.number.isRequired,
  type: PropTypes.string.isRequired,
  purchaseDate: PropTypes.instanceOf(Date),
  inWeight: PropTypes.number.isRequired,
  hedgeablePrice: PropTypes.number.isRequired,
  profitLoss: PropTypes.number.isRequired,
  breakevenPP: PropTypes.number.isRequired,
  breakevenBasis: PropTypes.number.isRequired,
  breakevenCDN: PropTypes.number.isRequired,
  breakevenFutures: PropTypes.number.isRequired,
  costOfGain: PropTypes.number.isRequired,
  purchasePricePerLb: PropTypes.number.isRequired,
})

FinishingList.propTypes = {
  data: PropTypes.arrayOf(FinishingItem),
}

export default FinishingList



// WEBPACK FOOTER //
// ./src/components/breakeven/finishingList.js